export default __webpack_public_path__ + "static/media/moon-icon.97d1c807.svg";